import React, { Component } from 'react'
import Modal from 'react-responsive-modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSync } from '@fortawesome/free-solid-svg-icons'

export class DepToLocation extends Component {

    render() {
        const { depToLocation, fetchDepToLocation } = this.props
        return (
            <Modal center={true} focusTrapped={false} open={this.props.visible} onClose={this.props.closeModal} showCloseIcon={true} classNames={{ overlay: 'overlay', modal: 'modal' }} >
                <div className='col flex-center h-full'>
                    {
                        depToLocation.vehicules.length > 0 ?
                        <h2 className='title3'>Choisir un vehicule</h2>
                        :
                        <h2 className='title3'>Choisir un client</h2>
                    }
                    {
                        fetchDepToLocation.loading ?
                            <div className='full lab-in row flex-center sync'>
                                <FontAwesomeIcon icon={faSync} spin />
                            </div>
                            :
                            <div className={`table-container`}>
                                <table>
                                    <thead>
                                        <tr>
                                            {
                                                depToLocation.vehicules.length > 0 ?
                                                    <>
                                                        <th>Plaques</th>
                                                        <th>Marque</th>
                                                        <th>Modèle</th>
                                                    </>
                                                    :
                                                    <>
                                                        <th>Nom</th>
                                                        <th>Prénom</th>
                                                    </>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            depToLocation.vehicules.length > 0 ?
                                                depToLocation.vehicules.map(vehicule =>
                                                    <tr key={`vehicule${vehicule.id}`}
                                                        onDoubleClick={() => this.props.dblClickVehicule(vehicule)}>
                                                        <td>{vehicule.plaques}</td>
                                                        <td>{vehicule.marque}</td>
                                                        <td>{vehicule.modele}</td>
                                                    </tr>
                                                )
                                                :
                                                depToLocation.clients.length > 1 ?
                                                    depToLocation.clients.map(client =>
                                                        <tr key={`client${client.id}`}
                                                            onDoubleClick={() => this.props.dblClickClient(client)}>
                                                            <td>{client.nom}</td>
                                                            <td>{client.prenom}</td>
                                                        </tr>
                                                    )
                                                    :
                                                    null
                                        }
                                    </tbody>
                                </table>
                            </div>
                    }
                </div>
            </Modal>
        )
    }
}